import { Routes } from 'react-router';
import LoginRoutes from './LoginRoutes';
import useStore from 'zustand-store';
import MainRoutes from './MainRoutes';
import { customClearTimeout, securelyRetrieveData } from 'utils';
import { useEffect } from 'react';

const AppRoutes = () => {

    const isLogged = useStore(state => state.isLogged);
    const loggedUser = useStore(state => state.loggedUser);
    const loggedTimeout = useStore(state => state.loggedTimeout);
    const setLoggedTimeout = useStore(state => state.setLoggedTimeout);
    const getLoggedUserDetails = useStore(state => state.getLoggedUserDetails);
    const getProfessionalAccountDetails = useStore(state => state.getProfessionalAccountDetails);
    const getTokenFromRefreshToken = useStore(state => state.getTokenFromRefreshToken);
    const userDidActionLock = useStore(state => state.userDidActionLock);
    const setUserDidActionLock = useStore(state => state.setUserDidActionLock);
    const logoutFront = useStore(state => state.logoutFront);

    const actions = [
        "click",
        "keypress",
        "mousemove",
        "mousedown",
        "scroll",
    ];

    const securitySeconds = 60;

    const calculateRemaningTimeInMS = (dateAsTime: number, sessionTime: number) => {
        let elaspedTime = ((new Date()).getTime() - dateAsTime);
        return sessionTime - elaspedTime - securitySeconds * 1000
    }

    const getTokenFromRefreshTokenProcess = async () => {
        await getTokenFromRefreshToken((isSuccess: boolean) => {
            if (isSuccess) {
                let newLoggedUser = securelyRetrieveData('loggedUser');
                if (newLoggedUser === undefined) {
                    logoutFront();
                } else {
                    customClearTimeout(loggedTimeout);
                    setLoggedTimeout((setTimeout(() => {
                        logoutFront();
                    }, calculateRemaningTimeInMS(newLoggedUser.date, newLoggedUser.expiration * 1000))))
                    setUserDidActionLock(false);
                }
            } else {
                logoutFront();
            }
        });
    }

    const handleRefreshOrAction = async (isRefreshOrAction: boolean) => {
        if (isLogged) {
            let cachedLoggedUser = securelyRetrieveData('loggedUser');
            if (cachedLoggedUser !== undefined) {
                if (isRefreshOrAction){
                    getLoggedUserDetails();
                    getProfessionalAccountDetails()
                }
                if (!(userDidActionLock)) {
                    setUserDidActionLock(true)
                    customClearTimeout(loggedTimeout);
                    setLoggedTimeout((setTimeout(() => {
                        (async () => {
                            await getTokenFromRefreshTokenProcess();
                        })();
                    }, calculateRemaningTimeInMS(cachedLoggedUser.date, cachedLoggedUser.expiration * 1000))))
                }
            }
            else {
                logoutFront();
            }
        }
    }

    const handleEvent = () => {
        (async () => {
            await handleRefreshOrAction(false);
        })()
    };

    useEffect(() => {
        (async () => {
            await handleRefreshOrAction(true);
        })()
        return () => {
            customClearTimeout(loggedTimeout);
        }
    }, []);

    useEffect(() => {
        actions.forEach((item) => {
            window.addEventListener(item, handleEvent);
        });
        return () => {
            actions.forEach((item) => {
                window.removeEventListener(item, handleEvent);
            });
        }
    }, [handleEvent]);

    return <Routes>{isLogged ? MainRoutes(loggedUser) : LoginRoutes}</Routes>;
}

export default AppRoutes;